import React from 'react';

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-[3px]',
  lg: 'h-10 w-10 border-4',
};

const LoadingSpinner = ({
  fullScreen = false,
  label = 'Loading…',
  showLabel = false,
  size = 'md',
  tone = 'blue',
}) => {
  const toneClasses = tone === 'light'
    ? 'border-white text-white'
    : 'border-blue-600 text-slate-600 dark:text-slate-300';

  const content = (
    <div
      className={`inline-flex items-center justify-center gap-3 ${toneClasses}`}
      role="status"
      aria-live="polite"
    >
      <span
        className={`inline-block animate-spin rounded-full border-r-transparent ${sizeClasses[size] || sizeClasses.md}`}
        aria-hidden="true"
      />
      {showLabel && <span className="text-sm font-semibold">{label}</span>}
      {!showLabel && <span className="sr-only">{label}</span>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6 dark:bg-slate-950">
        {content}
      </div>
    );
  }

  return <div className={`flex items-center justify-center ${size === 'sm' ? 'min-h-0' : 'min-h-10'}`}>{content}</div>;
};

export default LoadingSpinner;
